import React from 'react';
import useStyle from './tableDataCase.style';
import { classNames } from '../../../../../helpers/style/classNames';
import { IconButton } from '../../../../atoms/Buttons/IconButton';
import { Icon } from '../../../../atoms/Icons';

export interface TableDataCaseViewProps {
  variant: 'rank' | 'note' | 'data' | 'avatar' | 'icon' | 'name';
  icon?: Icon;
  color?:
    | 'normal'
    | 'red'
    | 'green'
    | 'blur'
    | 'transparent'
    | 'grey'
    | 'orange'
    | 'orangeOutlined'
    | 'orangeOutlinedGrey';
  line1: string | JSX.Element;
  onClick?: () => void;
}

export const TableDataCaseView = ({
  variant,
  icon,
  color,
  line1,
  onClick
}: TableDataCaseViewProps) => {
  const classes = useStyle();
  return (
    <td
      className={classNames([classes.root, classes[variant], classes[color]])}
    >
      {icon && (
        <IconButton onClick={onClick} variant={'backless'} icon={icon} />
      )}
      {variant !== 'avatar' && typeof line1 === 'string' ? (
        <p className={classes.text}>{line1}</p>
      ) : (
        line1
      )}
    </td>
  );
};
